import { render, staticRenderFns } from "./indsubindic.vue?vue&type=template&id=2bca8dbe&scoped=true&"
import script from "./indsubindic.vue?vue&type=script&lang=js&"
export * from "./indsubindic.vue?vue&type=script&lang=js&"
import style0 from "./indsubindic.vue?vue&type=style&index=0&id=2bca8dbe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca8dbe",
  null
  
)

export default component.exports